import React, { useState } from "react";
import "./Left_Sidebar.css";
import { Nav } from "react-bootstrap";
import Successfull_Modal from "../../common/modals/common-modal/successfull_modal/Successfull_Modal";
import Log_out_modal from "../../common/modals/common-modal/log-out-modal/Log_out_modal";

const Left_Sidebar = ({ onNavClick, onClose, setLogoutModal }) => {


  const sidebar = [
    {
      label: "Orders",
      img: "/assets/images/profile/left_sidebar/img1.png",
      innerTabs: [
        {
          label: "Ordered",
          img: "/assets/images/profile/left_sidebar/inner_img1.png",
        },
        {
          label: "Delivered",
          img: "/assets/images/profile/left_sidebar/inner_img2.png",
        },
        {
          label: "Cancelled",
          img: "/assets/images/profile/left_sidebar/inner_img3.png",
        },
        {
          label: "Returned",
          img: "/assets/images/profile/left_sidebar/inner_img4.png",
        },
      ],
    },
    {
      label: "Bookings",
      img: "/assets/images/profile/left_sidebar/inner_img5.png",
      innerTabs: [
        {
          label: "All Bookings",
          img: "/assets/images/profile/left_sidebar/inner_img6.png",
        },

      ],
    },
    {
      label: "Wishlist",
      img: "/assets/images/profile/left_sidebar/img2.png",
    },
    {
      label: "Wallet",
      img: "/assets/images/profile/left_sidebar/img3.png",
    },
    // {
    //   label: "Notifications",
    //   img: "/assets/images/profile/left_sidebar/img4.png",
    // },
    {
      label: "Have a Question?",
      img: "/assets/images/profile/left_sidebar/img5.png",
    },
    {
      label: "Log Out",
      img: "/assets/images/profile/left_sidebar/img6.png",
    },
  ];

  const [activeParent, setActiveParent] = useState(null);

  const handleParentClick = (label, hasInnerTabs) => {
    if (label === "Log Out") {
      setLogoutModal(true);
      onClose?.();
      return;
    }

    if (!hasInnerTabs) {
      onNavClick?.(label); // send main label to parent
      onClose?.();
      setActiveParent(null);
    } else {
      setActiveParent((prev) => (prev === label ? null : label));
    }
  };

  const handleInnerClick = (parentLabel, innerLabel) => {
    onNavClick?.(parentLabel, innerLabel); // send both to parent
    onClose?.();
  };

  return (
    <div className="Left_Sidebar">
      <Nav variant="pills" className="flex-column custom_sidebar_nav">
        {sidebar.map((item, index) => (
          <React.Fragment key={index}>
            <Nav.Item
              type="button"
              className={
                item.label === "Log Out"
                  ? "logout_nav parent_nav_item"
                  : "parent_nav_item"
              }
            >
              <Nav.Link
                onClick={() => handleParentClick(item.label, !!item.innerTabs)}
                eventKey={item.label.toLowerCase().replace(/\s+/g, "-")}
              >
                <div className="img_holder">
                  <img
                    className="tab_icon"
                    src={process.env.PUBLIC_URL + item.img}
                    alt={item.label}
                  />
                </div>
                <span className="tab_text">{item.label}</span>
              </Nav.Link>
            </Nav.Item>

            {activeParent === item.label &&
              item.innerTabs?.map((inner, idx) => (
                <Nav.Item className="inner_nav_item" key={`inner-${idx}`}>
                  <Nav.Link
                    onClick={() => handleInnerClick(item.label, inner.label)}
                    eventKey={
                      item.label.toLowerCase().replace(/\s+/g, "-") +
                      "-" +
                      inner.label.toLowerCase().replace(/\s+/g, "-")
                    }
                  >
                    <div className="img_holder">
                      <img
                        className="tab_icon"
                        src={process.env.PUBLIC_URL + inner.img}
                        alt={inner.label}
                      />
                    </div>
                    <span className="tab_text">{inner.label}</span>
                  </Nav.Link>
                </Nav.Item>
              ))}
          </React.Fragment>
        ))}
      </Nav>


    </div>
  );
};

export default Left_Sidebar;
